import script from "./ConfirmSingle.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfirmSingle.vue?vue&type=script&setup=true&lang=ts"

import "./ConfirmSingle.vue?vue&type=style&index=0&id=15b91d65&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15b91d65"]])

export default __exports__